module.exports = __webpack_public_path__ + "static/media/img3-3.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/nutricheck_foliar/K/img3-3.png
// module id = 1788
// module chunks = 3